import React, { Suspense, lazy } from 'react';
import logo from './logo.svg';
import './styles/sass/App.scss';

import {BrowserRouter as Router, Switch, NavLink, Route, Redirect} from "react-router-dom";
import { Position, Toast, Toaster, Classes, Alert, Intent} from "@blueprintjs/core";

import firebase from "./utils/firebaseSetUp";

import CircleLoader from "../src/components/loaders/CircleLoading";



const Selection = lazy(() => import("./components/Selection"));
const Auth = lazy(() => import("./components/Auth"));
const PanelHR = lazy(() => import("./components/humanResources/Panel"));
const PanelUsers = lazy(() => import("./components/users/PanelUsers"));

const PanelAdmin = lazy(() => import("./components/admin/PanelAdmin"));

class App extends React.Component {
  _mounted;
  _listenUser;

  constructor(props){
    super(props);

    this.state = {
      toasts:[],
      auth:false,
      userData:null,
      authenticating:false,
      companyData:null
    }

    this.toaster = {};
    this.refHandlers = {
        toaster:(ref) => {this.toaster = ref},
    }
  }

  mountUser = (id) => {
    if(this._listenUser !== undefined){
      this._listenUser(); // Clean up the listener
    }
   this._listenUser = firebase.firestore().collection("users").doc(id).onSnapshot(doc => {
      let data =doc.data();
      data.id = doc.id;

      if(this._mounted){
        this.setState({
          userData:data
        })
      }
    }, e => {
      console.log(e);
      this.addToast("Algo salió mal")
    })
  }

  componentDidMount(){
    this._mounted = true;

    

    if(this._mounted){
      this.setState({
        authenticating:true
      })
    }

    firebase.auth().onAuthStateChanged(u => {
     
      if(u){

        firebase.firestore().collection("users").doc(u.uid).get()
        .then(doc => {
          let data =doc.data();
          data.id = doc.id
          if(doc.exists){

            if(data.type === "company"){

              firebase.firestore().collection("companies").doc(data.companyID).get()
              .then(c => {
                let company = c.data();
                company.id = c.id;

                if(this._mounted){
                  this.addToast("Bienvenido!")
                  this.setState({
                    auth:true,
                    authenticating:false,
                    userData:data,
                    companyData:company
                  })
                }
              })
              .catch(e => {
                console.log(e);
                this.addToast("Algo salió mal");

                if(this._mounted){
                  this.setState({
                    authenticating:false,
                    auth:false,
                    userData:null
                  })
                }
              })

            }else {
            if(this._mounted){
              this.addToast("Bienvenido!")
              this.setState({
                auth:true,
                authenticating:false,
                userData:data
              }, () => {
                this.mountUser(data.id)
              })
            }
          }
          }else {
            this.addToast("No existe el usuarios")

            if(this._listenUser !== undefined){
              this._listenUser(); // Clean up the listener
            }
            if(this._mounted){
              this.setState({
                authenticating:false,
                auth:false,
                userData:null
              })
            }
          }
        })
        .catch(e => {
          console.log(e);

          this.addToast("Algo salió mal")

          if(this._mounted){
            this.setState({
              authenticating:false,
              auth:false,
              userData:null
            })
          }
        })
      }else {

        if(this._listenUser !== undefined){
          this._listenUser(); // Clean up the listener
        }

        if(this._mounted){
          this.setState({
            authenticating:false,
            userData:null,
            auth:false
          })
        }
      }
    })
  }

  componentWillUnmount(){
    this._mounted = false;
  }

  addToast = (message) => {
    this.toaster.show({ message: message});
}

  render(){
    return <div className="app">
        <Toaster className={Classes.OVERLAY} position={Position.TOP} ref={this.refHandlers.toaster}>
                    {/* "Toasted!" will appear here after clicking button. */}
                    {this.state.toasts.map(toast => <Toast action={{onClick:() => {}, text:"Resend"}} {...toast} />)}
                </Toaster>
        <Suspense fallback={<CircleLoader/>}>
          <Router>
            <Switch>
             <Route exact={true} path="/" render={() =>this.state.auth?this.state.userData.type === "company"?<Redirect to="/recursos-humanos"/>:this.state.userData.type === "user"?<Redirect to="/usuarios"/>:this.state.userData.type === "admin"?<PanelAdmin userData={this.state.userData} addToast={this.addToast}/>:<div></div>:<Redirect to="/ingreso"/>}/>
             <Route exact={true} path="/inicio" render={() => this.state.auth === false?<Selection addToast={this.addToast} authenticating={this.state.authenticating} userData={this.state.userData}/>:<Redirect to="/ingreso"/>}/>
             <Route exact={true} path="/ingreso" render={() => this.state.auth?this.state.userData.type === "company"?<Redirect to="/recursos-humanos"/>:this.state.userData.type === "user"?<Redirect to="/usuarios"/>:this.state.userData.type === "admin"?<Redirect to="/admin"/>:<div></div>:<Auth addToast={this.addToast} authenticating={this.state.authenticating} userData={this.state.userData}/>}/>
             <Route exact={true} path="/recursos-humanos" render={() => this.state.auth && this.state.userData.type === "company"?<PanelHR addToast={this.addToast} companyData={this.state.companyData} userData={this.state.userData}/>:<Redirect to="/"/>}/>
             <Route exact={true} path="/usuarios" render={() => this.state.auth && this.state.userData.type === "user"?<PanelUsers addToast={this.addToast} userData={this.state.userData}/>:<Redirect to="/"/>}/>
             <Route exact={true} path="/admin" render={() => this.state.auth && this.state.userData.type === "admin"?<PanelAdmin  addToast={this.addToast} userData={this.state.userData}/>:<Redirect to=""/>}/>
          </Switch>
          </Router>
        </Suspense>
    </div>
  }
}

export default App;
